import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import AppShell from "./components/AppShell";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import AgeGate from "./pages/AgeGate";
import Waiver from "./pages/Waiver";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Discover from "./pages/Discover";
import Grid from "./pages/Grid";
import Matches from "./pages/Matches";
import Chat from "./pages/Chat";
import Profile from "./pages/Profile";
import Premium from "./pages/Premium";
import PremiumSuccess from "./pages/PremiumSuccess";

function Router() {
    const location = useLocation();
    // CRITICAL: Handle Google OAuth callback via URL fragment BEFORE any other route
    // This prevents AuthProvider race conditions
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }

    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/age-gate" element={<AgeGate />} />
            <Route path="/waiver" element={<Waiver />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
                path="/onboarding"
                element={
                    <ProtectedRoute>
                        <Onboarding />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/discover"
                element={
                    <ProtectedRoute requireComplete>
                        <Discover />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/grid"
                element={
                    <ProtectedRoute requireComplete>
                        <Grid />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/matches"
                element={
                    <ProtectedRoute requireComplete>
                        <Matches />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/chat/:matchId"
                element={
                    <ProtectedRoute requireComplete>
                        <Chat />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/profile"
                element={
                    <ProtectedRoute>
                        <Profile />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/premium"
                element={
                    <ProtectedRoute>
                        <Premium />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/premium/success"
                element={
                    <ProtectedRoute>
                        <PremiumSuccess />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppShell>
                        <Router />
                    </AppShell>
                    <Toaster theme="dark" position="top-center" richColors closeButton />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
